/**
* Resources JS
* -----------------------------------------------------------------------------
*
* All the JS for the Resources component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'resources',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const cards = $( '.resources__card' );

      if ( cards.length ) {
        cards.each( function( index, element ) {
          const link = $( element ).find( '.resources__card-link' );
          const height = link.outerHeight();
          // Add the CSS variable to the element itself
          $( this ).css( '--link-height', `${height}px` );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'resources', COMPONENT );
} )( app );
